import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";

import { useDispatch } from "react-redux";
import QiwaPopUp from "../QiwaPopUp";
import nodeinstance from "../../../../../nodeInstance";

export default function ListQiwaContract({
  titles = [],
  list = [],
  updateData,
}) {
  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  const [listData, setListData] = useState({});
  const [Popup, setPopUp] = useState(false);

  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();
  const [data, setData] = useState();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(data ? data : list?.data || []);

  const [Apikey, setApiKey] = useState("");

  const onSearchChange = (e) => {
    setApiKey(e.target.value);
  };

  const onClearResponse = () => {
    setApiKey("");
    setData("");
  };
  const token = localStorage.getItem("nodeToken");
  const onSearchClick = async () => {
    try {
      const response = await nodeinstance.get(
        `/qiwaContract/search/${Apikey}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setData(response.data.data);
      }
    } catch (error) {
      console.log("error to be capctured here", error);
    }
  };
  const trigger = () => {
    onSearchClick();
    updateData();
  };
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 mt-2"
            onClick={() => {
              onClearResponse();
            }}
          >
            <p>Clear filter</p>
          </button>
          <div style={styles.container} className="mt-2">
            <input
              type="text"
              placeholder="Search employee here"
              style={styles.input}
              value={Apikey}
              onChange={(e) => {
                onSearchChange(e);
              }}
            />
            <span
              style={styles.tickIcon}
              onClick={() => {
                onSearchClick();
              }}
            >
              ✔️
            </span>
          </div>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-qiwa-contract auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}

          {!list?.isLoading
            ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.religion || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.current_sponsor
                          ? list.current_sponsor
                          : list.current_overseas_sponsor || "-"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>{list.uploaded_count}</p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.qiwa_status === "Qiwa Contract Uploaded"
                          ? "ACTIVE"
                          : list.qiwa_status || "-"
                      }
                    />
                  </p>

                  <button
                    className={
                      "p-1 px-2 rounded-md  bg-red text-white text-xs p-2 w-20"
                    }
                    onClick={() => {
                      setPopUp(true);
                      setListData(list);
                    }}
                    disabled={list.uploaded_count > 0}
                  >
                    VIEW DETAILS
                  </button>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
            : ""}
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <QiwaPopUp
          PopUp={Popup}
          setPopUp={setPopUp}
          title={""}
          data={listData}
          updateApi={trigger}
          isGrTrue = {true}
        />
      ) : (
        ""
      )}
    </>
  );
}
